import React from 'react';
import { 
  Box, 
  Typography, 
  Container, 
  Paper, 
  Button, 
  List, 
  ListItem, 
  ListItemIcon, 
  ListItemText, 
  useTheme,
  Divider
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import PaymentIcon from '@mui/icons-material/Payment';

const Pricing: React.FC = () => {
  const theme = useTheme();
  
  const features = [
    "Package static frontend files",
    "Package backend startup files",
    "Create executable for browser access",
    "Cross-platform compatibility",
    "One-click deployment",
    "Technical support",
    "Regular updates"
  ];
  
  return (
    <Box 
      id="pricing" 
      sx={{ 
        py: 8,
        background: theme.palette.mode === 'dark' 
          ? 'linear-gradient(45deg, #212121 30%, #303030 90%)' 
          : 'linear-gradient(45deg, #e0e0e0 30%, #f5f5f5 90%)',
      }}
    >
      <Container maxWidth="lg">
        <Box sx={{ mb: 6, textAlign: 'center' }}>
          <Typography 
            variant="h3" 
            component="h2" 
            gutterBottom
            sx={{ fontWeight: 'bold' }}
          >
            Pricing
          </Typography>
          <Typography 
            variant="h6" 
            color="textSecondary" 
            sx={{ maxWidth: 700, mx: 'auto' }}
          >
            Simple, transparent pricing to help you package and distribute your web applications.
          </Typography>
        </Box>
        
        <Box 
          sx={{ 
            display: 'flex', 
            justifyContent: 'center',
            flexDirection: { xs: 'column', md: 'row' },
            alignItems: 'center'
          }}
        >
          <Paper
            elevation={4}
            sx={{
              p: 4,
              width: { xs: '100%', md: '60%' },
              maxWidth: 600,
              borderRadius: 3,
              position: 'relative',
              overflow: 'hidden',
              background: theme.palette.background.paper,
              border: `1px solid ${theme.palette.divider}`,
              '&::before': {
                content: '""',
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '5px',
                background: theme.palette.primary.main,
              }
            }}
          >
            <Box sx={{ textAlign: 'center', mb: 3 }}>
              <Typography variant="h4" component="h3" gutterBottom sx={{ fontWeight: 'bold' }}>
                Annual License
              </Typography>
              <Typography variant="h3" component="div" sx={{ fontWeight: 'bold', color: theme.palette.primary.main }}>
                $680
                <Typography component="span" variant="h6" color="textSecondary" sx={{ ml: 1 }}>
                  / year
                </Typography>
              </Typography>
            </Box>
            
            <Divider sx={{ my: 3 }} />
            
            <List sx={{ mb: 3 }}>
              {features.map((feature, index) => (
                <ListItem key={index} sx={{ py: 1 }}>
                  <ListItemIcon sx={{ minWidth: 40, color: theme.palette.primary.main }}>
                    <CheckIcon />
                  </ListItemIcon>
                  <ListItemText primary={feature} />
                </ListItem>
              ))}
            </List>
            
            <Box sx={{ textAlign: 'center' }}>
              <Typography variant="body2" color="textSecondary" sx={{ mb: 2, fontStyle: 'italic' }}>
                *Payment methods: USDT (Note: Paypal international payments will be discontinued after June 15, 2024)
              </Typography>
              <Button 
                variant="contained" 
                color="primary" 
                size="large"
                href="/sign_in"
                startIcon={<PaymentIcon />}
                fullWidth
                sx={{ 
                  py: 1.5,
                  boxShadow: '0 4px 14px 0 rgba(0,118,255,0.39)'
                }}
              >
                Pay and Start
              </Button>
            </Box>
          </Paper>
        </Box>
      </Container>
    </Box>
  );
};

export default Pricing;
